///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class EmployeesWithCategories extends DataTemplateBase implements IDataTemplate {

        protected employeeCategories: EmployeeCategoriesCollection;
        protected employees: EmployeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.employeeCategories;
        }

        get leafCollection() {
            return this.employees;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[1]];
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        private _required: boolean;
        get required(): boolean {
            return this._required;
        }

        set required(value: boolean) {
            this._required = value;
            this.updateRequiredValidator(value, this.collection);
        }

        constructor(model: Dictionary<any>, protected properties: string[], { criteria, alwaysExcludeInactive = false }) {
            super(model, properties, criteria);

            this.employeeCategories = new EmployeeCategoriesCollection(this.model[properties[0]], [], {
                criteria
            });

            var employeeCriteria = angular.extend({
                view: Model.EmployeeSearchView.AllEmployeesWithCategories,
                includeActive: true,
                includeInactive: !alwaysExcludeInactive
            }, criteria);
            this.employees = new EmployeesCollection(this.model[properties[1]], [], {
                criteria: employeeCriteria
            });

            this.employees.setParentCollection(this.employeeCategories, CoreEmployeeToCategoryStrategy);
            if (this.model["showAllSelected"] == false) {
                this.showAllSelected = false;
            }

            this.title = 'LABEL_EMPLOYEES';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';
            this.filters = [];
            if (!alwaysExcludeInactive) {
                this.filters.push(new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this));
            }
                
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.employees.setWatchers(scope);
        }
    }
}